import Utils from "./utils";
import autoComplete from '@tarekraafat/autocomplete.js'

/* global KmClbScriptMain */

class Directory {
  constructor() {
    this.filters = document.querySelector('.js-clb-dir-filters');

    if (!this.filters) {
      return;
    }

    this.selectors = {
      autocomplete: '.js-dir-autocomplete',
      companySelect: '.js-dir-company-select',
    }

    this.DOM = {
      autocompletes: document.querySelectorAll(this.selectors.autocomplete),
      companySelect: document.querySelector(this.selectors.companySelect),
    }

    this.classnames = {
      loading: 'is-loading',
    }

    this.global = KmClbScriptMain;

    this.data = {
      files: {
        companies: 'directory-companies.json',
      },
      autocompleteInstance: null,
      threshold: 3,
    }

    this.autocomplete();
    this.companyDropdownHandler();
  }

  async autocompleteData(autocompleteKey) {
    const { filesUrl } = this.global.autocomplete;
    const fileName = this.data.files[autocompleteKey];

    const fileUrl = `${filesUrl}/${fileName}`;

    const response = await fetch(fileUrl);

    const data = await response.json();

    const list = data?.[autocompleteKey] || [];

    let listArray = Object.values(list);

    return listArray.sort();
  }

  autocomplete() {
    if (!this.DOM.autocompletes.length) {
      return;
    }

    this.DOM.autocompletes.forEach((autocomplete) => {
      const field = autocomplete;
      const { autocompleteKey } = field.dataset;

      this.data.autocompleteInstance = new autoComplete({
        selector: `#${field.getAttribute('id')}`,
        placeHolder: field.getAttribute('placeholder') || '',
        data: {
          src: async () => {
            return await this.autocompleteData(autocompleteKey);
          },
        },
        threshold: this.data.threshold,
        resultItem: {
            highlight: true,
        },
        resultsList: {
          maxResults: 20,
        }
      });

      field.addEventListener('selection', (e) => {
        const selectedValue = e.detail.selection.value;
        e.target.value = selectedValue;
        this.data.autocompleteInstance.close();

        if (this.DOM.companySelect) {
          const selectedOption = this.DOM.companySelect.querySelector(`[value="${selectedValue}"]`);

          if (selectedOption) {
            this.DOM.companySelect.value = selectedValue;
            //trigger change event
            this.DOM.companySelect.dispatchEvent(new Event('change'));
          }
        }
      });

      if (this.DOM.companySelect) {
        field.addEventListener('input', (e) => {
          if (e.target.value.length >= this.data.threshold) {
            this.DOM.companySelect.value = '';
          }
        });
      }
    });
  }

  companyDropdownHandler() {
    if (!this.DOM.companySelect) {
      return;
    }

    this.DOM.companySelect.addEventListener('change', (e) => {
      this.data.company = e.target.value;
      const selectedOption = e.target.options[e.target.selectedIndex];
      const { pageUrl } = selectedOption.dataset;

      if (pageUrl) {
        this.filters.classList.add(this.classnames.loading);
        window.location.href = pageUrl;
      }
    });
  }
}

export default Directory;
